import TitleBlock, { TitleBlockWrapper } from '@anm/components/TitleBlock';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import Input from '@anm/components/form/Input';
import CardModal, { CardModalContent } from '@anm/components/modals/CardModal';
import { SelectOptionsContainer } from '@anm/components/select/Select';
import getFromCdn from '@anm/helpers/getFromCdn';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

const mobileContent = media.phone`
  padding: 16px;
  max-height: unset;
`;

export const ModalWrapper = styled(CardModal)`
  ${CardModalContent} {
    width: 484px;
    padding: 25px 32px 31px;
    max-height: 100vh;
    overflow: auto;
    ${mobileContent};
  }

  ${TitleBlockWrapper} {
    max-width: 100%;
  }
`;

const mobileTitle = media.phone`
  font-size: 18px;
`;

export const ModalTitle = styled(TitleBlock)`
  text-align: center;
  h1,
  h2,
  h3,
  h4 {
    font-size: 24px;
    line-height: 32px;
    ${mobileTitle};
  }
`;

export const InputsWrapper = styled.div`
  margin-bottom: 24px;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  line-height: 17px;
  position: relative;
  margin-bottom: 18px;

  span {
    display: block;
    margin-bottom: 7px;
    color: #919eaa;
  }

  ${SelectOptionsContainer} {
    font-size: 16px;
  }
`;

export const FieldCounter = styled.span<{ isMax: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  && {
    color: var(${({ isMax }) => (isMax ? '--error' : '--gray_400')});
  }
`;

export const ButtonWrapper = styled(ButtonLoader)<{ isDisabledButton?: boolean }>`
  display: flex;
  font-size: 16px;
  line-height: 19px;
  ${({ isDisabledButton }) =>
    isDisabledButton &&
    css`
      background-color: #ced1d8;
      &&:hover {
        background-color: #ced1d8;
      }
    `}
`;

export const FolderPathInput = styled(Input)`
  padding-left: 44px;
  background: url(${getFromCdn('images/icons/folder_icon.svg')}) no-repeat 10px 7px, #fff;
`;
